import React, { Component } from 'react';
import { Union } from './Union.js';
import { TotalRow } from './TotalRow.js';
import '../styles/style.css';

export class Period extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true,
            totalMembers: 0,
            totalAffected: 0,
            totalUnemployed: 0,
            totalDefMembers: 0,
            totalBRMembers: 0,
            totalMFDMembers: 0,
            totalFFMembers: 0,
            totalArtaMembers: 0,
            totalAffectedDefMembers: 0,
            totalAffectedBRMembers: 0,
            totalAffectedMFDMembers: 0,
            totalAffectedFFMembers: 0,
            totalAffectedArtaMembers: 0,
            totalUnemployedDefMembers: 0,
            totalUnemployedBRMembers: 0,
            totalUnemployedMFDMembers: 0,
            totalUnemployedFFMembers: 0,
            totalUnemployedArtaMembers: 0
        }
    }

    handleCallbackPeriod = (childData) => {
        if (childData.indexOf('totalMembers') > -1) {
            var totalDefMembers = this.state.totalDefMembers;
            var totalBRMembers = this.state.totalBRMembers;
            var totalMFDMembers = this.state.totalMFDMembers;
            var totalFFMembers = this.state.totalFFMembers;
            var totalArtaMembers = this.state.totalArtaMembers;

            this.props.unions.forEach(function (union) {
                var newMembers = childData.replace('totalMembers:', '');

                if (union.name === "Dansk El-Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalDefMembers) < parseInt(newMembers.replace(union.name + ':', ''))) {
                    totalDefMembers = newMembers.replace(union.name + ':', '');
                }

                if (union.name === "Blik- og Rør arbejderforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalBRMembers) < parseInt(newMembers.replace(union.name + ':', ''))) {
                    totalBRMembers = newMembers.replace(union.name + ':', '');
                }

                if (union.name === "Malerforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalMFDMembers) < parseInt(newMembers.replace(union.name + ':', ''))) {
                    totalMFDMembers = newMembers.replace(union.name + ':', '');
                }

                if (union.name === "Fiskernes Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalFFMembers) < parseInt(newMembers.replace(union.name + ':', ''))) {
                    totalFFMembers = newMembers.replace(union.name + ':', '');
                }

                if (union.name === "Dansk Artist Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalArtaMembers) < parseInt(newMembers.replace(union.name + ':', ''))) {
                    totalArtaMembers = newMembers.replace(union.name + ':', '');
                }
            });

            this.setState({ totalDefMembers: totalDefMembers });
            this.setState({ totalBRMembers: totalBRMembers });
            this.setState({ totalMFDMembers: totalMFDMembers });
            this.setState({ totalFFMembers: totalFFMembers });
            this.setState({ totalArtaMembers: totalArtaMembers });

            this.setState({ totalMembers: parseInt(totalDefMembers) + parseInt(totalMFDMembers) + parseInt(totalBRMembers) + parseInt(totalFFMembers) + parseInt(totalArtaMembers) });

        }

        if (childData.indexOf('affected') > -1) {
            var totalAffectedDefMembers = this.state.totalAffectedDefMembers;
            var totalAffectedBRMembers = this.state.totalAffectedBRMembers;
            var totalAffectedMFDMembers = this.state.totalAffectedMFDMembers;
            var totalAffectedFFMembers = this.state.totalAffectedFFMembers;
            var totalAffectedArtaMembers = this.state.totalAffectedArtaMembers;
            this.props.unions.forEach(function (union) {
                var newMembers = childData.replace('affected:', '');
                var newNumber = newMembers.replace(union.name + ':', '');

                if (union.name === "Dansk El-Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalAffectedDefMembers) < parseInt(newNumber)) {
                    totalAffectedDefMembers = newNumber;
                }

                if (union.name === "Blik- og Rør arbejderforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalAffectedBRMembers) < parseInt(newNumber)) {
                    totalAffectedBRMembers = newNumber;

                }

                if (union.name === "Malerforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalAffectedMFDMembers) < parseInt(newNumber)) {
                    totalAffectedMFDMembers = newNumber;
                }

                if (union.name === "Fiskernes Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalAffectedFFMembers) < parseInt(newNumber)) {
                    totalAffectedFFMembers = newNumber;
                }

                if (union.name === "Dansk Artist Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalAffectedArtaMembers) < parseInt(newNumber)) {
                    totalAffectedArtaMembers = newNumber;
                }
            });

            this.setState({ totalAffectedDefMembers: totalAffectedDefMembers === undefined ? 0 : totalAffectedDefMembers });
            this.setState({ totalAffectedBRMembers: totalAffectedBRMembers });
            this.setState({ totalAffectedMFDMembers: totalAffectedMFDMembers });
            this.setState({ totalAffectedFFMembers: totalAffectedFFMembers });
            this.setState({ totalAffectedArtaMembers: totalAffectedArtaMembers });

            this.setState({ totalAffected: parseInt(totalAffectedDefMembers) + parseInt(totalAffectedBRMembers) + parseInt(totalAffectedMFDMembers) + parseInt(totalAffectedFFMembers) + parseInt(totalAffectedArtaMembers) });

        }

        if (childData.indexOf('unemployed') > -1) {
            var totalUnemployedDefMembers = this.state.totalUnemployedDefMembers;
            var totalUnemployedBRMembers = this.state.totalUnemployedBRMembers;
            var totalUnemployedMFDMembers = this.state.totalUnemployedMFDMembers;
            var totalUnemployedFFMembers = this.state.totalUnemployedFFMembers;
            var totalUnemployedArtaMembers = this.state.totalUnemployedArtaMembers;
            this.props.unions.forEach(function (union) {
                var newMembers = childData.replace('unemployed:', '');
                var newNumber = newMembers.replace(union.name + ':', '');

                if (union.name === "Dansk El-Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalUnemployedDefMembers) < parseInt(newNumber)) {
                    totalUnemployedDefMembers = newNumber;
                }

                if (union.name === "Blik- og Rør arbejderforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalUnemployedBRMembers) < parseInt(newNumber)) {
                    totalUnemployedBRMembers = newNumber;
                }

                if (union.name === "Malerforbundet" && newMembers.indexOf(union.name) > -1 && parseInt(totalUnemployedMFDMembers) < parseInt(newNumber)) {
                    totalUnemployedMFDMembers = newNumber;
                }

                if (union.name === "Fiskernes Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalUnemployedFFMembers) < parseInt(newNumber)) {
                    totalUnemployedFFMembers = newNumber;
                }

                if (union.name === "Dansk Artist Forbund" && newMembers.indexOf(union.name) > -1 && parseInt(totalUnemployedArtaMembers) < parseInt(newNumber)) {
                    totalUnemployedArtaMembers = newNumber;
                }
            });

            this.setState({ totalUnemployedDefMembers: totalUnemployedDefMembers });
            this.setState({ totalUnemployedBRMembers: totalUnemployedBRMembers });
            this.setState({ totalUnemployedMFDMembers: totalUnemployedMFDMembers });
            this.setState({ totalUnemployedFFMembers: totalUnemployedFFMembers });
            this.setState({ totalUnemployedArtaMembers: totalUnemployedArtaMembers });

            this.setState({ totalUnemployed: parseInt(totalUnemployedDefMembers) + parseInt(totalUnemployedBRMembers) + parseInt(totalUnemployedMFDMembers) + parseInt(totalUnemployedFFMembers) + parseInt(totalUnemployedArtaMembers) });    
        }
    }

    getUnions(unions) {
        let unionsArr = [];

        for (let i = 0; i < unions.length; i++) {
            if (unions[i].name === "Dansk Artist Forbund" && parseInt(this.props.year) === 2024 && parseInt(this.props.month) > 4 || unions[i].name === "Dansk Artist Forbund" && parseInt(this.props.year) > 2024) {
                continue;
            }

            if (unions[i].branches !== undefined && unions[i].branches.length > 0) {
                unionsArr.push(<Union key={unions[i].name + i} name={unions[i].name} branches={unions[i].branches} period={this.props.year + ":" + this.props.month} parentCallback={this.handleCallbackPeriod} />);
                
            }
            if (unions[i].areas !== undefined && unions[i].areas.length > 0) {
                unionsArr.push(<Union key={unions[i].name + i} name={unions[i].name} unionareas={unions[i].areas} period={this.props.year + ":" + this.props.month} parentCallback={this.handleCallbackPeriod} />);
            }
        }

        return unionsArr;
    }

    getMonthName(monthNumber) {
        const monthNames = ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'];

        return monthNames[monthNumber - 1];
    }

    render() {
        return (
            <div className='period-container'>
                <div className={this.state.hide ? "period-hide" : "period-show"}>
                    <div onClick={() => { this.setState({ hide: !this.state.hide }); }}>
                        <h3>{this.props.year} {this.getMonthName(this.props.month)}</h3>
                    </div>
                    <div>
                        <div><h4 onClick={() => { this.setState({ hide: !this.state.hide }); }}>Ledige hos FAK ialt</h4></div>
                        <div key={0}><div key={0} className='table-header row'><div className='col1'></div><div className='col2'></div><div className='col3'>Antal medlemmer</div><div className='col4'>Fuldtids<br className='wordsplit' />ledige</div><div className='col5'>Fuldtids ledighed</div><div className='col6'>Berørte</div><div className='col7'>Berørtes ledighed</div></div></div>
                        <div className='total-even'><TotalRow totalMembers={this.state.totalMembers} unemployed={this.state.totalUnemployed} affected={this.state.totalAffected} /></div>
                        {this.getUnions(this.props.unions)}
                    </div>
                </div>
            </div>
        );
    }
}